import * as Consts from './Consts';
const TABS_ITEMS_PADDING = 210;
import * as Colors from 'material-ui/styles/colors';

export default {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  header: {
    height: Consts.TITLE_HEIGHT,
    backgroundColor: Colors.grey800,
    position: 'relative',
  },
  tabItems: {
    width: Consts.DIALOG_WIDTH - 2 * TABS_ITEMS_PADDING,
    height: Consts.TITLE_HEIGHT,
    backgroundColor: Colors.grey800,
    marginLeft: TABS_ITEMS_PADDING,
    display: 'flex',
    alignItems: 'flex-end'
  },
  inkBar: {
    transform: 'translate(' + TABS_ITEMS_PADDING + 'px)',
    backgroundColor: Colors.lightGreen600,
    height: 4
  },
  // tabContent: {
  //   backgroundColor: 'white',
  //   height: Consts.TAB_CONTENT_HEIGHT,
  //   maxHeight: Consts.TAB_CONTENT_MAX_HEIGHT,
  //   overflowY: 'auto',
  //   position: 'relative',
  // },
  buttonsSection: {
    height: Consts.BUTTONS_SECTION_HEIGHT,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    position: 'absolute',
    left: 0,
    bottom: 0,
  },
  imagesPreviewContainer: {
    display: 'flex',
    flexShrink: 0,
    paddingTop: 20,
    paddingLeft: 80,
    paddingRight: 80,
    height: 250,
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  previewAndProps: {
    backgroundColor: 'white',
    width: 'calc(100% - 120px)',
    height: Consts.TAB_CONTENT_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 60,
    paddingRight: 60,
    overflow: 'hidden'
  },
  dialogTitle: {
    position: 'absolute',
    margin: 20,
    top: 0,
    left: 0,
    color: Colors.white,
    fontSize: 24
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5
  },
  mainButton: {
    marginRight: 12.5,
    height: '55px',
    minWidth: 140
  },
  zoomButton: {
    fontSize: 30,
    color: Colors.grey800
  },
};
